import { Injectable } from '@angular/core';
import { BehaviorSubject, distinctUntilChanged } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DisplayModeService {
  private _helpzone$ = new BehaviorSubject<boolean>(false);
  readonly helpzone$ = this._helpzone$.pipe(distinctUntilChanged());
  private _chatBanner$ = new BehaviorSubject<boolean>(false);
  readonly chatBanner$ = this._chatBanner$.pipe(distinctUntilChanged());

  toggleHelpzone(state: boolean) {
    this._helpzone$.next(state);
  }

  toggleChatBanner(state: boolean) {
    this._chatBanner$.next(state);
  }
}
